/**
 * Facebook Pixel Tracking Utilities
 * Pixel ID: 1339085864197225
 */

/**
 * Track Facebook Pixel event (client-side only)
 */
export function trackFacebookEvent(
  event: string,
  params?: Record<string, any>
) {
  if (typeof window === 'undefined' || !(window as any).fbq) {
    console.warn('Facebook Pixel not loaded');
    return;
  }

  try {
    (window as any).fbq('track', event, params);
    console.log('Facebook Pixel tracked:', event, params);
  } catch (error) {
    console.error('Facebook Pixel tracking error:', error);
  }
}

/**
 * Track Lead - quando usuário gera logo/mascote
 */
export function trackFacebookLead(contentName?: string) {
  trackFacebookEvent('Lead', {
    content_name: contentName || 'Logo/Brand Generation',
    content_category: 'Brand Kit',
  });
}

/**
 * Track InitiateCheckout - quando abre modal de pagamento
 */
export function trackFacebookInitiateCheckout(params: {
  value: number;
  currency?: string;
  content_name: string;
  content_ids?: string[];
}) {
  trackFacebookEvent('InitiateCheckout', {
    value: params.value,
    currency: params.currency || 'BRL',
    content_name: params.content_name,
    content_ids: params.content_ids || ['kit-marca-completo'],
    content_type: 'product',
  });
}

/**
 * Track Purchase - após pagamento aprovado
 */
export function trackFacebookPurchase(params: {
  value: number;
  currency?: string;
  content_name: string;
  content_ids?: string[];
}) {
  trackFacebookEvent('Purchase', {
    value: params.value,
    currency: params.currency || 'BRL',
    content_name: params.content_name,
    content_ids: params.content_ids || ['kit-marca-completo'],
    content_type: 'product',
  });
}
